import LocalStorageManager from "./LocalStorageManager.service";

class AutenticationService{
    static isAutenticate = () => {
        let val = LocalStorageManager.getItem('s_islogged') ??false;        
        return val;
    }
        
    static getUser = () => LocalStorageManager.getItem('s_sid')??'';
    static getUserName = () => LocalStorageManager.getItem('s_name');
    static getUserNameComplete = () => LocalStorageManager.getItem('s_name') + ' ' + LocalStorageManager.getItem('s_fname');
    static getEmail = () => LocalStorageManager.getItem('s_email')??'';
    static getPPID = () => LocalStorageManager.getItem('s_ppid')??'';
    static getIsLogged = () => JSON.parse(LocalStorageManager.getItem('s_islogged')??'false');
    
    static getRegistered = () => LocalStorageManager.getItem('s_status')==="completed"||LocalStorageManager.getItem('s_status')==="active";
}

export default AutenticationService;